import "core-js/modules/es6.object.freeze";
import mdiSvg from "./mdi-svg";
import md from "./md";
import mdi from "./mdi";
import fa from "./fa";
import fa4 from "./fa4";
import faSvg from "./fa-svg";
export default Object.freeze({
  mdiSvg: mdiSvg,
  md: md,
  mdi: mdi,
  fa: fa,
  fa4: fa4,
  faSvg: faSvg
});